module.exports = __webpack_public_path__ + "media/summer_2023_sweepstakes/facebook-e9791b15.svg";